import { vocabularyCs } from "../localize/localize-cs";
export const slugify = (value, separator = '-') => {
    if (typeof value !== 'string')
        return '';
    return value
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9 ]/g, '')
        .replace(/\s+/g, separator);
};
export function inflect(key, number) {
    if (vocabularyCs[key] === undefined) {
        return key;
    }
    let index = 0;
    if (number === 1) {
        index = 1;
    }
    else if ([2, 3, 4].includes(number)) {
        index = 2;
    }
    return vocabularyCs[key][index];
}
